import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Maybe, WorkspaceDetails } from '@/types/schema';

const ProviderItem: React.FC<{ workspace: Maybe<WorkspaceDetails> }> = ({ workspace }) => {
  const { t } = useTranslation();
  const { workspaceName, workspaceLogo } = workspace!;

  // To-do: revert this after updated designs.
  return <></>;
  // return (
  //   <Stack alignItems="center" gapX={16}>
  //     <Image alt={workspaceName!} className="w-40 h-40" objectFit="contain" src={workspaceLogo!} />
  //     <Stack alignItems="start" direction="col">
  //       <Typography color="text-text-primary" variant="body-short-01">
  //         {workspaceName}
  //       </Typography>
  //       <Typography color="text-text-secondary" variant="body-short-02">
  //         {t('Common:SourceAcademy')}
  //       </Typography>
  //     </Stack>
  //   </Stack>
  // );
};

const ProviderComponent: React.FC<{ workspace: Maybe<WorkspaceDetails>; className?: string }> = ({
  className,
  workspace,
}) => {
  const { t } = useTranslation();

  // To-do: revert this after updated designs.
  return <></>;
  // return (
  //   <Stack className={className} direction="col">
  //     <Typography as="h2" className="mb-24" variant="heading-m">
  //       {t('Common:Provider')}
  //     </Typography>
  //     <ProviderItem workspace={workspace} />
  //   </Stack>
  // );
};

export default ProviderComponent;
export { ProviderItem };
